import { X } from "lucide-react";

/** Fixed-width desktop panel used as a context toolbar / catalog sidebar. */
export function DesktopSidePanel({ children }: { children: React.ReactNode }) {
  return (
    <aside className="hidden md:flex md:w-[340px] md:shrink-0 bg-white border-l border-ink-200 flex-col min-h-0">
      {children}
    </aside>
  );
}

/** Header shown when the side panel is editing a selected canvas item. */
export function SelectionPanelHeader({
  title,
  meta,
  swatch,
  onClose,
  eyebrow = "Selected",
}: {
  title: string;
  meta?: string;
  swatch?: React.ReactNode;
  onClose: () => void;
  eyebrow?: string;
}) {
  return (
    <div className="px-5 pt-[calc(var(--topbar-h)+1rem)] pb-3 border-b border-ink-100 shrink-0">
      <div className="flex items-start gap-3">
        {swatch && <div className="shrink-0 pt-0.5">{swatch}</div>}
        <div className="flex-1 min-w-0">
          <div className="text-caption uppercase tracking-wide text-ink-400 font-semibold">
            {eyebrow}
          </div>
          <h2 className="text-xl font-bold text-ink-900 mt-1 truncate">{title}</h2>
          {meta && (
            <p className="text-sm text-ink-500 mt-1 truncate tabular-nums">{meta}</p>
          )}
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="size-8 inline-flex items-center justify-center rounded-full hover:bg-ink-100 active:bg-ink-200 transition-colors shrink-0"
        >
          <X className="size-4 text-ink-500" />
        </button>
      </div>
    </div>
  );
}
